var render = function render(){var _vm=this,_c=_vm._self._c;return _c('module-wrapper',{attrs:{"instance":_vm.instance}},[_c('p',[_vm._v("More Information Footer")]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }